import { gql } from '@apollo/client';

export const INTEGRATION_OVERRIDE_FIELDS = gql`
    fragment IntegrationOverrideFields on integration_overrides {
        carrier_id
        client_id
        config
        middle_mile_carrier_id
        integration_meta_type_id
        override_id
        shipper_id
        status
        type
    }
`;
